import React from 'react';
import cx from 'classnames';
import styles from './HeadingCard.module.scss';
import HeadingCardProps from './HeadingCard.types';
import Heading from '../Heading';

const HeadingCard = ({
  children,
  className,
  centerContent,
  dataCy,
  headerText,
  heading = 'h2',
  noPadding,
}: HeadingCardProps) => {
  let card = (
    <div
      data-cy={dataCy}
      className={cx(styles.card, className, {
        [styles.center]: centerContent,
        [styles.noPadding]: noPadding,
      })}>
      {children}
    </div>
  );

  if (headerText) {
    card = (
      <>
        <Heading heading={heading}>{headerText}</Heading>
        {card}
      </>
    );
  }

  return card;
};

export default HeadingCard;
